<template>
<div class="footer_container">
  <div class="logo">
    <img @click="homeRD" src="@/assets/EmilyLogoPNG-10.png" alt="Logo" />
  </div>

  <div class="quick_links">
    <h1>Quick Links</h1>
    <p @click="pageRD('resume')">My Resume</p>
    <p @click="pageRD('work')">My Work</p>
    <p @click="pageRD('contact')">Contact Me</p>
  </div>
  <div class="find_links">
    <h1>Where to find me</h1>
    <p @click="mediaRD('instagram')">Instagram</p>
    <p @click="mediaRD('linkedIn')">LinkedIn</p>
    <p @click="pageRD('contact')">Email</p>
  </div>
  <div class="nav_links">
    <div class="headings">
      <h1 @click="pageRD('home')">Home</h1>
      <h1 @click="topRD">Top</h1>
      <h1 id="download_link" @click="downloadResume">Download Resume</h1>
    </div>
    <p>Copyright &#9426; 2020 Emily Elder Creates</p>
  </div>
</div>
</template>

<script src="./Footer.js"></script>

<style src="./Footer.scss" lang="scss"></style>
